import { Box, List, ListItem, Typography } from "@mui/material";
import { ExamSection } from "../exam/type";
import QuestionItem from "../question/QuestionItem";

function SectionPanel({
  section,
  showAnswers,
}: {
  section: ExamSection;
  showAnswers: boolean;
}) {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {section.examSectionType.examSectionName}
      </Typography>
      <List>
        {section.questions.map((question) => (
          <ListItem
            key={`${section.sectionOrder}-${question.number}`}
            disablePadding
            sx={{ display: "block", mb: 2 }}
          >
            <QuestionItem question={question} showAnswers={showAnswers} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
export default SectionPanel;
